import "primeicons/primeicons.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import { createApp } from "vue";

import api from "@/api";
import { ApiInjectionKey, testDirective } from "@/utilities";

import { globals } from "./plugins/globals";
import { http } from "./plugins/http";
import { pinia } from "./plugins/pinia";

import Lara from "@primevue/themes/lara";
import { definePreset } from "@primevue/themes";

var customPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: "var(--global-primary-50)",
      100:"var(--global-primary-100)",
      200:"var(--global-primary-200)",
      300:"var(--global-primary-300)",
      400:"var(--global-primary-400)",
      500:"var(--global-primary-500)",
      600:"var(--global-primary-600)",
      700:"var(--global-primary-700)",
      800:"var(--global-primary-800)",
      900:"var(--global-primary-900)",
      950:"var(--global-primary-950)",
    },
  },
  components: {
    inputtext: {
      colorScheme: {
        light: {
          invalid: { border: { color: "var(--bs-form-invalid-border-color)" } },
          focus: {
            ring: {
              shadow: "0 0 0 0.25rem var(--global-primary-200)",
            },
            border: {
              color: "var(--global-primary-400)",
            },
          },
          padding: {
            y: "0.375rem",
            x: "0.75rem",
          },
        },
      },
    },
    select: {
      colorScheme: {
        light: {
          invalid: { border: { color: "var(--bs-form-invalid-border-color)" } },
          focus: {
            ring: {
              shadow: "0 0 0 0.25rem var(--global-primary-200)",
            },
            border: {
              color: "var(--global-primary-400)",
            },
          },
          padding: {
            y: "0.375rem",
            x: "0.75rem",
          },
        },
      },
    },
  },
});

function app() {
  return createApp({})
    .provide("http", http)
    .provide(ApiInjectionKey, api)
    .use(PrimeVue, {
      theme: {
        preset: customPreset,
        options: {
          darkModeSelector: ".my-app-dark",
        },
      },
    })
    .use(ToastService)
    .use(pinia)
    .use(globals)
    .directive("test", testDirective)
    .mount("[data-behavior='vue']");
}

document.addEventListener("DOMContentLoaded", app);
